import { requestDesktopPermission } from "./permission-needed-event";

/** Called after a live voice permission failure; cached grants cannot dismiss it. */
export async function ensureVoicePermissionsForFeatureUse(): Promise<boolean> {
  requestDesktopPermission("microphone");
  return false;
}
